// extracted by mini-css-extract-plugin
export default {"container":"WY0dmP","title":"sMIsKE","textButton":"gkReN3"};